<template>
  <div class="space-y-4 p-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 进厂指引管理"
      :showReturn="false"
    />
    <el-button
      v-has="['c-base-mp-guide-add']"
      @click="onAdd"
      size="medium"
      type="primary"
      >添加</el-button
    >
    <el-button
      v-has="['c-base-mp-guide-delete']"
      @click="onDelete"
      size="medium"
      >删除</el-button
    >
    <div class="space-x-4 text-sm">
      <span>
        指引类型
      </span>
      <el-select
        v-model="queryParam.type"
        placeholder="请选择指引类型"
        class="w-60"
      >
        <el-option value="" label="全部"></el-option>
        <el-option
          v-for="(label, value) in guideTypes"
          :key="value"
          :label="label"
          :value="value"
        ></el-option>
      </el-select>
      <span>
        指引名称
      </span>
      <el-input
        v-model="queryParam.name"
        clearable
        placeholder="请输入指引名称"
        class="w-60"
      ></el-input>
      <span>
        车辆业务类型
      </span>
      <el-input
        v-model="queryParam.car_business_name"
        clearable
        placeholder="请输入车辆业务类型"
        class="w-60"
      ></el-input>
    </div>
    <c-table
      isSelection
      :selection.sync="rowKeySelection"
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="update_time" slot-scope="scope">
        {{ scope.row.update_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link
            v-has="['c-base-mp-guide-update']"
            @click="onEdit(scope.row)"
            label="修改"
          ></c-link>
          <c-link
            @click="onDelete(scope.row, 1)"
            v-has="['c-base-mp-guide-delete']"
            label="删除"
            type="danger"
          ></c-link>
        </el-row>
      </template>
    </c-table>
    <guideModal ref="guideModal" @ok="onSearch" />
  </div>
</template>

<script>
import guideModal from "./components/guideModal.vue";
import initListMinxin from "@/mixins/jl/initListMinxin";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      queryParam: {
        type: "",
        car_business_name: ""
      },
      guideTypes: {
        1: "取样指引",
        2: "卸货指引",
        3: "提货指引"
      },
      columns: [
        {
          label: "基地",
          prop: "baseName",
          formatData: () => this.baseInfo.com_name
        },
        { label: "指引名称", prop: "name" },
        {
          label: "类型",
          prop: "type",
          formatData: row => this.guideTypes[row.type] || "--"
        },
        {
          label: "车辆业务类型",
          prop: "car_business_list",
          formatData: row =>
            row.car_business_list && row.car_business_list.length > 0
              ? row.car_business_list.map(item => item.name).join("、")
              : "--"
        },
        { label: "维护人", prop: "update_by_name" },
        { label: "最近维护时间", prop: "update_time" },
        { width: 140, label: "操作", prop: "action" }
      ],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_guide",
          data: params
        }),
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除进厂指引？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_guide"
      }
    };
  },
  mixins: [initListMinxin],
  computed: {
    ...mapGetters(["baseInfo"])
  },
  components: {
    guideModal
  },
  methods: {
    onEdit(row) {
      this.$refs.guideModal.onOpen(row);
    },
    onAdd() {
      this.$refs.guideModal.onOpen();
    }
  }
};
</script>
